import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, ref } from "vue";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useRoute } from "vue-router";
import NewRouteApplicationEdit from "@/components/bbs/newRoute/NewRouteApplicationEdit.vue";
import NewRouteApplicationDetail from "@/components/bbs/newRoute/NewRouteApplicationDetail.vue";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import Modal from "@/components/shared/modal/base/Modal.vue";
import { useUserStore } from "@/stores/userStore";
import AddressSearchMap from "@/components/map/AddressSearchMap.vue";
import { useBbsStore } from "@/stores/bbsStore";
import { INewRouteApplicationDetail } from "@/domain/entities/bbs";
import router from "@/router";
import { IAddressSearchInfo } from "@/domain/entities/address";
import AddressInfoMap from "@/components/map/AddressInfoMap.vue";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "NewRouteApplication",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const route = useRoute();

const bbsStore = useBbsStore();
const userStore = useUserStore();
const userInfo = computed(() => userStore.userInfo);

const createMode = ref(route.path.includes("/apply")); // 신규노선신청 등록화면으로 들어온 경우에만 true
const editMode = ref(createMode.value);
const newRouteUid = ref(route.params.uid?.toString()); // 신규노선신청 상세화면으로 들어온 경우에만 가지고 있음
const applicationDetail = ref<INewRouteApplicationDetail>();
const isMyPost = computed(
  () =>
    applicationDetail.value?.memberUid !== undefined &&
    userInfo.value?.uid === applicationDetail.value?.memberUid
);

const handleClickBack = () => {
  if (createMode.value || !editMode.value) {
    router.back();
  } else {
    toggleEditMode(false);
  }
};

// 선택된 주소 정보 입력하기
const setAddressInfo = (address: IAddressSearchInfo) => {
  selectedAddress.value = address;
  applicationDetail.value = {
    ...applicationDetail.value,
    roadAddress: address.roadAddress,
    dongAddress: address.dongAddress,
    detailAddress: "",
    lat: address.latitude,
    lng: address.longitude,
  } as INewRouteApplicationDetail;
};

const selectedAddress = ref<IAddressSearchInfo | undefined>();

// 신규 노선/정류장 신청 상세 데이터 수정하기
const updateApplicationDetail = (updateData: Record<string, string>) => {
  applicationDetail.value = {
    ...applicationDetail.value,
    ...updateData,
  } as INewRouteApplicationDetail;
};

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const toggleEditMode = (mode: boolean) => {
  editMode.value = mode;
};

const address = computed(() => {
  const address: IAddressSearchInfo = {
    zipNo: "",
    dongAddress: applicationDetail.value?.dongAddress ?? "",
    dongNo: "",
    roadAddress: applicationDetail.value?.roadAddress ?? "",
    roadNo: "",
    isUnder: false,
    buildingMainNo: 0,
    buildingSubNo: 0,
    latitude: applicationDetail.value?.lat,
    longitude: applicationDetail.value?.lng,
  };

  return address;
});
const shouldShowAddressInfoMap = ref(false);
const toggleShowAddressInfoMap = (show: boolean) => {
  shouldShowAddressInfoMap.value = show;
};

const shouldShowAddressSearchMap = ref(false);
const toggleShowAddressSearchMap = (show: boolean) => {
  shouldShowAddressSearchMap.value = show;
};

const shouldShowDeleteConfirmModal = ref(false);
const toggleShowDeleteConfirmModal = (show: boolean) => {
  shouldShowDeleteConfirmModal.value = show;
};

const shouldShowReceiveResultConfirmModal = ref(false);
const toggleShowReceiveResultConfirmModal = (show: boolean) => {
  shouldShowReceiveResultConfirmModal.value = show;
};

const getNewRouteDetail = async (uid: string) => {
  const result = await bbsStore.getNewRouteApplicationDetail(uid);
  if (!result.isSuccess) {
    handleError("노선신청 상세 오류", result);
    return;
  }
  applicationDetail.value = result.data;
};

const deleteNewRouteApplication = async () => {
  if (!isMyPost.value || !!applicationDetail.value?.replies?.length) return;

  const result = await bbsStore.deleteNewRouteApplication(newRouteUid.value);
  if (!result.isSuccess) {
    handleError("신규 노선/정류장 신청 삭제오류", result);
    return;
  }
  showToastMessage("게시글이 삭제되었습니다");
  route.meta.willGoBack = true;
  router.back();
};

const requestReceiveResult = async () => {
  const result = await bbsStore.receiveNewRouteApplicationResult(
    newRouteUid.value
  );
  if (!result.isSuccess) {
    handleError("검토결과 수신오류", result);
    return;
  }
  getNewRouteDetail(newRouteUid.value);
  showToastMessage("신청이 완료되었습니다");
};

onMounted(() => {
  if (newRouteUid.value) {
    getNewRouteDetail(newRouteUid.value);
  }
});

const __returned__ = { showErrorModal, showToastMessage, route, bbsStore, userStore, userInfo, createMode, editMode, newRouteUid, applicationDetail, isMyPost, handleClickBack, setAddressInfo, selectedAddress, updateApplicationDetail, handleError, toggleEditMode, address, shouldShowAddressInfoMap, toggleShowAddressInfoMap, shouldShowAddressSearchMap, toggleShowAddressSearchMap, shouldShowDeleteConfirmModal, toggleShowDeleteConfirmModal, shouldShowReceiveResultConfirmModal, toggleShowReceiveResultConfirmModal, getNewRouteDetail, deleteNewRouteApplication, requestReceiveResult, Page, NavigationBar, NewRouteApplicationEdit, NewRouteApplicationDetail, Modal, AddressSearchMap, AddressInfoMap, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})